import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useAxios from "../../../hook/useAxios";
import { Department } from "../../../type/department";
import BreadCrumb from "../../Global/BreadCrumb";
import AddPlantingForm from "../AddPlanting/AddPlantingForm";
import EditSlider from "../../Global/EditSlider";
import Loading from "../../Global/Loading";

const EditPlanting = () => {
  const [selectOption, setSelectOption] = useState<{
    department: Department[];
    psa: Department[];
    ins: Department[];
    ind: Department[];
  }>({ department: [], ind: [], ins: [], psa: [] });
  const { t } = useTranslation();
  const { id } = useParams<any>();

  const { fetchData, response } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/plantings/${id}/edit/`,
    "PUT",
    false,
    "",
    true,
    true
  );

  const {
    fetchData: getEvent,
    response: getEditResponse,
    loading,
  } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/plantings/${id}/edit/`,
    "GET",
    false,
    "",
    true,
    true
  );

  const { response: departmentRes } = useAxios(
    process.env.REACT_APP_API_URL + "/api/admin/departments/all/",
    "GET",
    true,
    "",
    false,
    false
  );

  const { response: psaRes } = useAxios(
    process.env.REACT_APP_API_URL +
      "/api/admin/organizers/names/?organizer_type=psa",
    "GET",
    true,
    "",
    false,
    false
  );

  const { response: indRes } = useAxios(
    process.env.REACT_APP_API_URL +
      "/api/admin/organizers/names/?organizer_type=ind",
    "GET",
    true,
    "",
    false,
    false
  );

  const { response: insRes } = useAxios(
    process.env.REACT_APP_API_URL +
      "/api/admin/organizers/names/?organizer_type=ins",
    "GET",
    true,
    "",
    false,
    false
  );

  useEffect(() => {
    if (departmentRes) {
      setSelectOption((prevState) => {
        return {
          ...prevState,
          department: departmentRes.data,
        };
      });
    }
    if (psaRes) {
      setSelectOption((prevState) => {
        return {
          ...prevState,
          psa: psaRes.data,
        };
      });
    }
    if (indRes) {
      setSelectOption((prevState) => {
        return {
          ...prevState,
          ind: indRes.data,
        };
      });
    }
    if (insRes) {
      setSelectOption((prevState) => {
        return {
          ...prevState,
          ins: insRes.data,
        };
      });
    }
  }, [departmentRes, indRes, insRes, psaRes]);

  useEffect(() => {
    getEvent({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addOrganizerName = (type: string, value: Department) => {
    if (type === "psa") {
      let psa = selectOption.psa;
      psa.push(value);
      setSelectOption({
        department: selectOption.department,
        ind: selectOption.ind,
        ins: selectOption.ins,
        psa: psa,
      });
    } else if (type === "ind") {
      let ind = selectOption.ind;
      ind.push(value);
      setSelectOption({
        department: selectOption.department,
        ind: ind,
        ins: selectOption.ins,
        psa: selectOption.psa,
      });
    } else if (type === "ins") {
      let ins = selectOption.ins;
      ins.push(value);
      setSelectOption({
        department: selectOption.department,
        ind: selectOption.ind,
        ins: ins,
        psa: selectOption.psa,
      });
    }
  };

  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Plantings.Edit planting")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Plantings.Plantings"), url: "/plantings" },
          { name: t("Plantings.Edit planting"), url: "" },
        ]}
      />
      {loading ? (
        <Loading loading={true} />
      ) : (
        <div className="flex flex-wrap justify-between mt-4">
          <div className=" w-full h-fit lg:w-[49%] sc:w-[611px] bg-white rounded-md p-7 relative">
            <AddPlantingForm
              addOrganizer={addOrganizerName}
              selectOptions={selectOption}
              send={fetchData}
              sendResponse={response}
              getInfo={getEditResponse}
              textButton={t("Tree Species.Update")}
            />
          </div>
          <EditSlider
            images={["/img/Add Event.svg"]}
            response={getEditResponse}
          />
        </div>
      )}
    </div>
  );
};

export default EditPlanting;
